import {type TrackingEvent} from '../types';

export const PaymentsEvents = {
    NEW_DEBT_COLLECTION_PAGE_OPENED: {
        name: 'New debt collection: Page opened',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_PAGE_LEFT: {
        name: 'New debt collection: Page left',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_FILTER_APPLIED: {
        name: 'New debt collection: Filter applied',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_SEND_REMINDERS_BUTTON_CLICKED: {
        name: 'New debt collection: Send reminders button clicked',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_REMINDERS_SENT: {
        name: 'New debt collection: Reminders sent',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_EXPORT_BUTTON_CLICKED: {
        name: 'New debt collection: Export button clicked',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
    NEW_DEBT_COLLECTION_SEARCH_BUTTON_CLICKED: {
        name: 'New debt collection: Search button clicked',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
} satisfies Record<string, TrackingEvent>;
